import { Gesture } from "./Gesture";
import { localPlayerContainer, PlatformScaleMode } from "../localplayer/LocalPlayerContainer";
import { GestureType } from "flavr-common";
const SCALE_MIN = 0.01;
const SCALE_MAX = 100;
export class GrabScaleGesture extends Gesture {
    constructor(gestureModule, view) {
        super(GestureType.GrabScale, true);
        this.gestureModule = gestureModule;
        this.view = view;
        this.startScale = 0;
        this.startDist = 0;
    }
    begin() {
        this.startScale = localPlayerContainer.getPlatformScale();
        const data = this.gestureModule.currData;
        if (data.primaryController && data.secondaryController && data.angle) {
            this.startDist = data.primaryController.position.distanceTo(data.secondaryController.position);
            this.view.onBeginScaling(data.angle);
        }
    }
    update() {
        const data = this.gestureModule.currData;
        if (data.primaryController && data.secondaryController && data.angle) {
            const dist = data.primaryController.position.distanceTo(data.secondaryController.position);
            const angle = data.angle;
            this.view.update(data.primaryController.position, data.secondaryController.position, angle, dist / this.startDist);
            const targetScale = (this.startScale * this.startDist) / dist;
            const scaleFactor = targetScale / localPlayerContainer.getPlatformScale();
            localPlayerContainer.scalePlatform(scaleFactor, SCALE_MAX, SCALE_MIN, PlatformScaleMode.KEEP_USER_FEET_POSITION_CONSTANT);
        }
    }
    end() {
        this.view.reset();
    }
}
